import cfg from '../../config.js'
export const domain = process.env.VUE_APP_AUTH0_DOMAIN
export const clientId = process.env.VUE_APP_AUTH0_CLIENT_ID
export const audience = process.env.VUE_APP_AUTH0_AUDIENCE
